// When enabled, unauthenticated visitors landing on the root URL see the
// maintenance page instead of being redirected to the login page.
export const MAINTENANCE_MODE =
  String(process.env.REACT_APP_MAINTENANCE_MODE) === 'true';
